import _ from 'lodash';

import { COMMON_DATE_FORMAT } from 'constants/date';
import { CreditEventType } from 'constants/loanApplication';
import { formatCalendarDate } from 'utils/date';

import {
  DEROGATORY_EVENT_SOURCE_LABELS,
  DEROGATORY_EVENT_TYPE_LABELS,
} from './DerogatoryEventsTable.constants';

const formatDate = value => (value ? formatCalendarDate(value, COMMON_DATE_FORMAT) : null);

const getEventLabel = ({ eventType, bankruptcyChapter }) => {
  const label = DEROGATORY_EVENT_TYPE_LABELS[eventType] ?? eventType;

  return bankruptcyChapter ? `${label} (Chapter ${bankruptcyChapter})` : label;
};

const getEventDates = ({ eventType, filedDate, dispositionType, dispositionDate, eventDate }) => {
  if (eventType !== CreditEventType.BANKRUPTCY) {
    return formatDate(eventDate) ?? '-';
  }

  const disposition = dispositionType
    ? `${dispositionType}${dispositionDate ? ` ${formatDate(dispositionDate)}` : ''}`
    : null;

  return _.compact([filedDate && `Filed ${formatDate(filedDate)}`, disposition]).join(' · ') || '-';
};

const getEventDetails = ({ creditorName, courtName, docketIdentifier, bureaus, rawText }) =>
  _.compact([
    creditorName,
    courtName,
    docketIdentifier && `Docket ${docketIdentifier}`,
    bureaus,
    rawText && `“${rawText}”`,
  ]).join(' · ') || '-';

/**
 * The borrower's derogatory credit events as table rows: what happened, when, how reliable the
 * reading is, and which part of the credit report it came from.
 */
export const getDerogatoryEventRows = derogatoryEvents =>
  _.orderBy(
    derogatoryEvents ?? [],
    [({ dispositionDate, filedDate, eventDate }) => dispositionDate ?? filedDate ?? eventDate],
    ['desc'],
  ).map(event => ({
    id: event.id,
    event: getEventLabel(event),
    dates: getEventDates(event),
    reliability: event.reliability ?? null,
    source: DEROGATORY_EVENT_SOURCE_LABELS[event.source] ?? event.source ?? '-',
    details: getEventDetails(event),
  }));
